import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { dayColor, makeRowColumn, getHeadObj } from 'lib/commonLib';
import { adidStatusStatisticsData } from 'lib/api/datacenter';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import AdidStatusGraph from './AdidStatusGraph';

const AdidStatusStatistics = (props) => {
  const { appadiddayGraph, adidGraphList, extraKey } = props;
  const { t } = useTranslation();
  const tableType = queryString.parse(window.location.search).tableType;

  let initParams = {
    sort: 'desc',
    order: 'STATS_DTTM',
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    type: tableType != undefined ? tableType : 'pairing',
    table: tableType != undefined ? tableType : 'duple',
    tableType: tableType != undefined ? tableType : '',
    ...extraKey,
  };
  const isSubPage = typeof extraKey !== 'undefined';

  let subAdidGraphList;
  if (isSubPage && tableType != undefined) {
    subAdidGraphList = [
      {
        data: {
          bar: ['NEW_ADID_T'],
          line: ['ACT_ADID_T'],
          individually: true,
        },
        yAxisData: {
          left: { ACT_ADID_T: true },
          right: { NEW_ADID_T: true },
          individually: true,
        },
        customizeData: {
          NEW_ADID_T: { keyLabel: t('ADID_신규') },
          ACT_ADID_T: { keyLabel: t('ADID_활성화') }
        },
      },
    ];
  } else {
    subAdidGraphList = [
      {
        data: {
          bar: ['ADID_PAIRING3', 'NEW_ADID_T'],
          line: ['ACT_ADID_T'],
          individually: true,
        },
        yAxisData: {
          left: { ACT_ADID_T: true },
          right: { NEW_ADID_T: true, ADID_PAIRING3: true },
          individually: true,
        },
        customizeData: {
          NEW_ADID_T: { keyLabel: t('ADID_신규') },
          ACT_ADID_T: { keyLabel: t('ADID_활성화') },
          ADID_PAIRING3: { keyLabel: t('아이디페어링') },
        },
      },
    ];
  }

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['STATS_DTTM'] !== 'total'
          ? dayColor(rowObj['STATS_DTTM'])
          : rowObj['STATS_DTTM'];
      },
    },
    ACC_STATUS: {
      makeBody: (rowObj, headsMap) => {
        const accStatus = getHeadObj(headsMap, 'ACC_STATUS');
        return (
          rowObj['STATS_DTTM'] !== 'total' &&
          makeRowColumn(rowObj['ACC_STATUS'], accStatus.type, accStatus.format)
        );
      },
      orderFlag: true,
    },
    ACT_ADID: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'ACT_ADID').label}
            <br />
            {t('(6개월 기준)')}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const item1 = getHeadObj(headsMap, 'ACT_ADID');
        return (
          rowObj['STATS_DTTM'] !== 'total' &&
          makeRowColumn(rowObj['ACT_ADID'], item1.type, item1.format)
        );
      },
      orderFlag: true,
    },
    ACT_RATE: {
      makeBody: (rowObj, headsMap) => {
        const item1 = getHeadObj(headsMap, 'ACT_RATE');
        return (
          rowObj['STATS_DTTM'] !== 'total' &&
          makeRowColumn(rowObj['ACT_RATE'], item1.type, item1.format)
        );
      },
      orderFlag: true,
    },
    NEW_ADID: { orderFlag: true },
    ADID_PAIRING: { orderFlag: true },
    OUT_ADID: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'OUT_ADID').label} <br />
            {t('(6개월 기준)')}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const accStatus = getHeadObj(headsMap, 'OUT_ADID');
        return (
          rowObj['STATS_DTTM'] !== 'total' &&
          makeRowColumn(rowObj['OUT_ADID'], accStatus.type, accStatus.format)
        );
      },
      orderFlag: true,
    },
    PAIRING_RATE: {
      makeBody: (rowObj, headsMap) => {
        const item1 = getHeadObj(headsMap, 'PAIRING_RATE');
        return (
          rowObj['STATS_DTTM'] !== 'total' &&
          makeRowColumn(rowObj['PAIRING_RATE'], item1.type, item1.format)
        );
      },
      orderFlag: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setParams(initParams);
      setInitialization(true);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
        />
      </NewFilterWrap>
      <AdidStatusGraph
        params={{ sDate: params.sDate, eDate: params.eDate, type: params.type, table: params.table, tableType: params.tableType, ...extraKey }}
        appadiddayGraph={appadiddayGraph}
        adidGraphList={isSubPage ? subAdidGraphList : adidGraphList}
      />
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={adidStatusStatisticsData}
        customized={customized}
        useFetch={false}
        useSearch={false}
        useTotal={!isSubPage}
      />
    </>
  );
};

export default AdidStatusStatistics;
